//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum BranchResolverRequestOutcome {
	InFlight = "InFlight",
	Completed = "Completed",
	NetworkError = "NetworkError",
	RequestTimeout = "RequestTimeout",
	HttpError = "HttpError",
	InvalidResponse = "InvalidResponse",
	OverallDeadline = "OverallDeadline",
	Canceled = "Canceled"
}
